import { AxiosInstance } from "axios";
import { IEventCategory } from "../interfaces/IEventCategory";
import { IEventSubCategory } from "../interfaces/IEventSubCategory";


export class EventCategoryService {
    private apiClient: AxiosInstance;
    private endpoint: string;

    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
        this.endpoint = '/category';
    }

    async getAll(): Promise<IEventCategory[]> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async getSubCategories(categoryId: string): Promise<IEventSubCategory[]> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${categoryId}/subcategories`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}
